import { useParams, useNavigate } from "react-router-dom";
import { createContext, useContext, useEffect } from "react";
import { DEFAULT_LANG, getPreferredLanguage, SUPPORTED_LANGS } from "./routesLocalized";
import LoadingBackdrop from "../Components/LoadingBackdrop/LoadingBackdrop";
import i18n from "./i18n";
import { useCookiebot } from "./useCookieBot";

const LangContext = createContext();

export default function LanguageLayout({ children }) {
    const { lng } = useParams();
    const navigate = useNavigate();

    const isValid = Boolean(lng) && SUPPORTED_LANGS.includes(lng);

    useCookiebot(isValid ? lng : null);

    useEffect(() => {
        if (!isValid) {
            const preferred = getPreferredLanguage();
            const target = SUPPORTED_LANGS.includes(preferred) ? preferred : DEFAULT_LANG;

            const segments = window.location.pathname.split("/").filter(Boolean);
            const looksLikeLocale = /^[a-z]{2}(-[a-z]{2})?$/i.test(segments[0] || "");
            const rest = (looksLikeLocale ? segments.slice(1) : segments).join("/");

            const { search, hash } = window.location;
            navigate(`/${target}${rest ? `/${rest}` : ""}${search}${hash}`, { replace: true });
            return;
        }

        if (i18n.language !== lng) {
            i18n.changeLanguage(lng).then(() => {
                setTimeout(() => {
                    window.updateSvgBoxes?.();
                    window.updateAiAgentSvgBoxes?.();
                }, 0);
            });
        }
        document.documentElement.lang = lng;
    }, [lng, isValid, navigate]);

    if (!isValid) return <LoadingBackdrop open={true} />;

    return <LangContext.Provider value={lng}>{children}</LangContext.Provider>;
}

export function useLanguage() {
    const context = useContext(LangContext);
    if (!context) {
        throw new Error("useLanguage must be used within an LanguageLayout");
    }
    return context;
}